import { render, staticRenderFns } from "./DuplicateWarning.vue?vue&type=template&id=8dcd8190&"
import script from "./DuplicateWarning.vue?vue&type=script&lang=js&"
export * from "./DuplicateWarning.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateWarning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports